import validate from "/work/release/fe-oj-ninja/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@20.17.57_db0@0.3.2_eslint@_p46ffyktbbexzolaknm7qzttwe/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/work/release/fe-oj-ninja/middleware/auth.global.ts";
import manifest_45route_45rule from "/work/release/fe-oj-ninja/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@20.17.57_db0@0.3.2_eslint@_p46ffyktbbexzolaknm7qzttwe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  home: () => import("/work/release/fe-oj-ninja/middleware/home.ts")
}